// Greg's household books. The page and its data come straight from cain-household.netlify.app
// (its own Neon database and passkey sign-in); CPx only frames it and never sees the numbers.
import React, { useState } from 'react';

const HOUSEHOLD_URL = 'https://cain-household.netlify.app/';

export default function Household() {
  // The banner's "Review them" button asks for the Review tab. Read once, so a redraw
  // doesn't reload the frame back to Overview.
  const [src] = useState(() => {
    let tab = null;
    try { tab = sessionStorage.getItem('household-tab'); sessionStorage.removeItem('household-tab'); } catch { /* ok */ }
    return tab ? `${HOUSEHOLD_URL}?tab=${encodeURIComponent(tab)}` : HOUSEHOLD_URL;
  });
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 90px)' }}>
      <div style={{ textAlign: 'right', fontSize: 12, padding: '0 4px 6px' }}>
        <a href={HOUSEHOLD_URL} target="_blank" rel="noopener noreferrer">Open in its own tab</a>
      </div>
      <iframe
        title="Cain Household"
        src={src}
        allow="publickey-credentials-get *; publickey-credentials-create *"
        style={{ flex: 1, width: '100%', border: '1px solid #e3e7ed', borderRadius: 8, background: '#f6f7f9' }}
      />
    </div>
  );
}
